import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Disclaimer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <Link
            to="/"
            className="inline-flex items-center text-blue-300 hover:text-blue-200 transition-colors mb-4"
          >
            ← {t('backToHome', 'Back to Home')}
          </Link>
          <h1 className="text-4xl font-bold mb-4">{t('footer.disclaimer')}</h1>
          <p className="text-gray-300">
            {t('disclaimer.lastUpdated', 'Last updated: January 2025')}
          </p>
        </div>

        {/* Content */}
        <div className="max-w-4xl space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('disclaimer.generalInformation.title', '1. General Information')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('disclaimer.generalInformation.content',
                'The information contained on this website is for general information purposes only. While we endeavor to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the website or the information, products, services, or related graphics contained on the website.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('disclaimer.noWarranties.title', '2. No Warranties')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('disclaimer.noWarranties.content',
                'This website is provided "as is" without any representations or warranties, express or implied. We make no representations or warranties in relation to this website or the information and materials provided on this website.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('disclaimer.limitationOfLiability.title', '3. Limitation of Liability')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('disclaimer.limitationOfLiability.content',
                'In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('disclaimer.accuracyOfMaterials.title', '4. Accuracy of Materials')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('disclaimer.accuracyOfMaterials.content',
                'The materials appearing on this website could include technical, typographical, or photographic errors. We do not warrant that any of the materials on its website are accurate, complete, or current. We may make changes to the materials contained on its website at any time without notice.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('disclaimer.externalLinks.title', '5. Links to External Sites')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('disclaimer.externalLinks.content',
                'Through this website, you may be able to link to other websites which are not under our control. We have no control over the nature, content, and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('disclaimer.personalResponsibility.title', '6. Personal Responsibility')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('disclaimer.personalResponsibility.content',
                'Every effort is made to keep the website up and running smoothly. However, we take no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('disclaimer.professionalAdvice.title', '7. Not Professional Advice')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('disclaimer.professionalAdvice.content',
                'The content on this website is for informational purposes only and should not be considered professional advice. Always seek the advice of qualified professionals regarding any specific questions you may have.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('disclaimer.modifications.title', '8. Modifications')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('disclaimer.modifications.content',
                'We may revise these terms of use for its website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of use.'
              )}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              {t('disclaimer.contact.title', '9. Contact Information')}
            </h2>
            <p className="text-gray-300 leading-relaxed">
              {t('disclaimer.contact.content',
                'If you have any questions about this disclaimer, please contact us at: '
              )}
              <a
                href="mailto:toby.brooks@tobybrooks.com"
                className="text-blue-300 hover:text-blue-200 transition-colors"
              >
                toby.brooks@tobybrooks.com
              </a>
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="mt-16 pt-8 border-t border-gray-600">
          <p className="text-center text-gray-400">
            © 2025 Toby Brooks. {t('footer.allRightsReserved', 'All rights reserved.')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;